import * as React from 'react';
import {useEffect, useState} from 'react';
import {translate, useApiErrors, useAuth, useEvent, useLazyCommand} from '@soap/modules'
import {CenterSpinner, ValidationNotification} from '@soap/baseweb'
import {Centered, SpaceTop} from "../z40-uicomp/layout";
import {useStyletron} from "baseui";
import {NavLink, useParams} from "react-router";
import {useUserRole} from "../hooks/useUserRole";
import {useLoginRedirect} from "../hooks/useLoginRedirect";

export function AcceptInvitation2({}) {

    //* styling 
    const [css, theme] = useStyletron();

    const {invitationId} = useParams();

    const viewStates = {
        loading: 0,
        creatingAccount: 1,
        invitationIdNotValid: 2,
        redirecting: 3
    };


    const [acceptInvitationTrigger] = useLazyCommand("C238v1_AcceptInvitation");
    const [viewState, setViewState] = useState(invitationId ? viewStates.loading : viewStates.invitationIdNotValid);
    const {isAuthenticated, authReady, refresh, accessToken} = useAuth("accept-invitation2");
    const {isStudent} = useUserRole();
    const loginRedirect = useLoginRedirect();

    useEffect(() => {

            if (authReady) {
                console.warn(1, "auth ready");
                if (!invitationId) {
                    setViewState(viewStates.invitationIdNotValid);
                } else if (viewState === viewStates.loading) {
                    console.warn(3, "starting signup");
                    setViewState(viewStates.creatingAccount);
                    acceptInvitationTrigger({
                        C238_InvitationId: invitationId
                    });
                }
            }
        }
        , [authReady, isAuthenticated, invitationId, acceptInvitationTrigger]);

    useEvent({
        eventName: "E191v1_AccountCreatedFromInvitation",
        onEventReceived: (e, v) => {
            (async function () {
                //* C238 adds roles and token needs refreshing
                console.warn("refreshing tokens", accessToken);
                await refresh({ignoreCache: true});
                console.warn("refreshing tokens", accessToken);
                // Redirect based on user role
                setViewState(viewStates.redirecting);
            }());
        }
    }, [refresh, accessToken, loginRedirect]);

    //* need to make students (and later tutors) orgroles (subaccount orgrolekey) and redo permissions on that basis
    // when accepting invite s

    useApiErrors((newError, errors) => {
        setViewState(viewStates.invitationIdNotValid);
    })

    switch (viewState) {
        case viewStates.loading:
            return (<CenterSpinner/>);
        case viewStates.creatingAccount:
            return (
                <div className="lyw-container min-h-screen bg-gray-50">
                    <main className="sm:ml-64 pb-16 sm:pb-0">
                        <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
                            <div className="text-center">
                                <NavLink to="/" className="block hover:opacity-80 transition-opacity">
                                    <h2 className="text-xl font-bold text-gray-900">Learn Your Way</h2>
                                </NavLink>
                                <Centered>Preparing your account</Centered>
                                <Centered>Please wait ...</Centered>
                                <SpaceTop>
                                    <CenterSpinner/>
                                </SpaceTop>
                            </div>
                        </div>
                    </main>
                </div>
            );
        case viewStates.invitationIdNotValid:
            return (
                <div className="lyw-container min-h-screen bg-gray-50">
                    <main className="sm:ml-64 pb-16 sm:pb-0">
                        <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
                            <div className="text-center">
                                <NavLink to="/" className="block hover:opacity-80 transition-opacity">
                                    <h2 className="text-xl font-bold text-gray-900">Learn Your Way</h2>
                                </NavLink>
                                <ValidationNotification errorMsg={translate("$linkInvalid")}/>
                            </div>
                        </div>
                    </main>
                </div>
            );
        case viewStates.redirecting:
            loginRedirect();
            return (<CenterSpinner/>);
    }

}